import React, { useState, useEffect } from 'react';
import { Layout, List, Space, notification, Row, Typography } from 'antd';
import Button from '@mui/material/Button'
import {DeleteForeverRounded, BookmarksRounded} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import PageHeader from "../../components/PageHeader";
import TouchpointEditor from "./TouchpointEditor";
import { fetchTouchpoint, createTouchpoint, updateTouchpoint, deleteTouchpoint } from "../../api/userApi";
import {iconMapping} from "../../configs/AppsConfig";
import TimeCell from "../../components/TimeCell";

const Touchpoints = () => {
    const dispatch = useDispatch();
    const touchpointDetails = useSelector((state) => state.user.data?.touchpoint_details || []);
    const [editorOpen, setEditorOpen] = useState(false);
    const [touchpoint, setTouchpoint] = useState({ title: '', content: null });
    const [isEditMode, setIsEditMode] = useState(false);
    const [editKey, setEditKey] = useState(Math.random()); // Key for forcing reinitialization

    const handleFetchTouchpoint = (touchpointId) => {
        const existingTouchpoint = touchpointDetails.find(tp => tp.id === touchpointId);
        if (existingTouchpoint && !existingTouchpoint.content) {
            // If touchpoint exists but lacks content, fetch it
            dispatch(fetchTouchpoint(touchpointId)).then(action => {
                if (action.payload) {
                    setTouchpoint({
                        ...existingTouchpoint,
                        content: action.payload
                    });
                    setIsEditMode(true);
                }
            });
        } else if (existingTouchpoint) {
            // If touchpoint already has content, use it directly
            setTouchpoint(existingTouchpoint);
            setIsEditMode(true);
            setEditorOpen(true)
        } else {
            // Fetch if touchpoint doesn't exist in the state (edge case)
            dispatch(fetchTouchpoint(touchpointId)).then(action => {
                if (action.payload) {
                    setTouchpoint({ id: touchpointId, content: action.payload });
                    setIsEditMode(true);
                }
            });
        }
    };


    const handleRemoveTouchpoint = (touchpointId) => {
        dispatch(deleteTouchpoint({touchpointId})).then(() => {});
    }


    const resetTouchpoint = ()=>{
        setIsEditMode(false)
        setTouchpoint({ title: '', content: null });
        setEditKey(Math.random());
        setEditorOpen(true);
    }

    const btn = (
      <Space>
        <Button type="link" size="small" onClick={() => resetTouchpoint()}>
          New Touchpoint
        </Button>
      </Space>
    );

    const handleSave = (updatedTouchpoint) => {
        const action = isEditMode ? updateTouchpoint : createTouchpoint;
        console.log(updatedTouchpoint)
        const kwargs = isEditMode ? {touchpointId: touchpoint.id, data: updatedTouchpoint} : {data: updatedTouchpoint}
        dispatch(action(kwargs)).then(() => {
            notification.open({
                ket: 'touchpoint-saved',
                message: "Touchpoint Saved",
                description: `Touchpoint "${updatedTouchpoint.title}" has been saved successfully.`,
                btn,
                showProgress: true,
                pauseOnHover: true,
            })
        });
    };




    return (
        <>
            <PageHeader
                title="Touchpoints"
                logoUrl={iconMapping.touchpoints}
                actions={[
                    <Button
                        variant="contained"
                        onClick={()=>setEditorOpen(false)}
                        startIcon={<BookmarksRounded/>}>
                        View Touchpoints
                    </Button>,
                ]}
            />
            <Layout style={{height: '100%'}}>
                <Layout.Content style={{ padding: '2.5%' }}>
                    {!editorOpen && (
                        <div style={{ width: 500, margin: 'auto' }}>
                            <Button type="primary" onClick={resetTouchpoint} block style={{ marginBottom: 16 }}>
                                Create New Touchpoint
                            </Button>
                            <List
                                itemLayout="horizontal"
                                dataSource={touchpointDetails}
                                renderItem={item => (
                                    <List.Item actions={[
                                        <Button type="link" onClick={() => handleFetchTouchpoint(item.id)}>Edit</Button>,
                                        <Button type={'error'} onClick={()=>handleRemoveTouchpoint(item.id)}><DeleteForeverRounded/></Button>
                                    ]}>
                                        <List.Item.Meta
                                            title={<Typography.Title level={5}>{item.title}</Typography.Title>}
                                            description={<TimeCell timestamp={item.create_timestamp} />}
                                        />
                                    </List.Item>
                                )}
                            />
                        </div>
                    )}
                    {editorOpen===true && (
                        <div style={{margin: 'auto'}}>
                            <TouchpointEditor
                                key={editKey}
                                touchpoint={touchpoint}
                                onSave={handleSave}
                                onChangeTitle={title => setTouchpoint(prev => ({ ...prev, title }))}
                                onChangeContent={content => setTouchpoint(prev => ({ ...prev, content }))}
                            />
                        </div>
                    )}
                </Layout.Content>
            </Layout>
        </>
    );
};

export default Touchpoints;
